import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleMapsLoader from 'google-maps';

import mapOptions from '../../../data/map-options';

class ContactMap extends Component {
    constructor(props) {
        super(props);
        this.map = null;
        this.marker = null;

        this.initMap = this.initMap.bind(this);
    }

    componentDidMount() {
        const { language } = this.props;
        GoogleMapsLoader.KEY = 'AIzaSyDmzZYzSO4gaZ2Wo5Jr4ZTIVd3TVD-Fh_k';
        GoogleMapsLoader.LIBRARIES = ['places'];
        GoogleMapsLoader.LANGUAGE = [language];
        GoogleMapsLoader.load(this.initMap);
    }

    initMap() {
        const { t } = this.props;
        const map = new window.google.maps.Map(document.getElementById('contact-map'), {
            zoom: 12,
            options: mapOptions
        });
        const request = {
            placeId: t('contact.map.placeId'),
            fields: ['name', 'formatted_address', 'place_id', 'geometry', 'adr_address', 'url']
        };
        const service = new window.google.maps.places.PlacesService(map);
        const infowindow = new window.google.maps.InfoWindow();
        service.getDetails(request, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                const marker = new window.google.maps.Marker({
                    map,
                    position: place.geometry.location
                });
                map.setCenter(marker.getPosition());
                const content = `
                <div style="border-radius: 2px;">
                <div  jstcache="0">
                    <div jstcache="117" style="display:flex; justify-content: space-between" class="place-card place-card-large">  
                        <div class="place-desc-large"> 
                            <div jstcache="36" class="place-name" jsan="7.place-name"><strong>${ place.name }</strong></div> 
                            <div jstcache="37" class="address" jsan="7.address">${ place.formatted_address }</div> 
                            </br>
                            <div jsaction="placeCard.directions" > 
                            <a target="_blank"jstcache="52" style="color: #007acc" href=${ t('contact.map.infowindow.navigate_url') } class="navigate-link"> 
                                <div class="icon navigate-icon"></div> 
                                <div jstcache="53" class="navigate-text">${ t('contact.map.infowindow.navigate_text') }</div> 
                            </a> 
                        </div> 
                        </div> 
                        
                        <div jstcache="38" class="navigate" style="display:flex; flex-direction: column; align-items: flex-end; justify-content: flex-end;"> 
                            </br>
                            <div class="review-box"> 
                            <a 
                            target="_blank" jstcache="44" style="color: #007acc"
                            href=${ t('contact.map.infowindow.review_url') } 
                            jsaction="mouseup:placeCard.reviews" 
                            jsan="7.review-box-link,8.href,0.target,22.jsaction"
                            >
                                ${ t('contact.map.infowindow.review_text') }
                            </a>
                            </div> 
                            </br>
                            <div class="large-map-box"> 
                            <a 
                                target="_blank" jstcache="44" style="color: #007acc" 
                                href=${ place.url } jsaction="mouseup:placeCard.reviews" jsan="7.review-box-link,8.href,0.target,22.jsaction"
                            >
                                ${ t('contact.map.infowindow.large_map_text') }
                            </a>
                            </div> 
                        </div> 
                    </div>  </div></div></div>`;

                window.google.maps.event.addListener(marker, 'click', () => {
                    infowindow.setContent(content);
                    infowindow.open(map, this);
                });
                infowindow.setContent(content);
                infowindow.open(map, marker);
            }
        });
    }

    render() {
        return (
            <div className="contact-map-container">
                <div id="contact-map" className="contact-map"/>
            </div>
        );
    }
}

ContactMap.propTypes = {
    t: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired
};


export default ContactMap;



// WEBPACK FOOTER //
// ./src/components/content/contact/ContactMap.jsx